module.exports = "/images/gotham-9.jpg";